/* global grecaptcha */
/* global ga */
/* global $ */

/*
recaptcha_action    - ganalytics_eventCategory ganalytics_eventAction ganalytics_eventLabel

login               - User get login
register            - User create register
contact             - Message create contact
*/

const RECAPTCHA_SITE_KEY = process.env.MIX_GOOGLE_RECAPTCHA_KEY;
const RECAPTCHA_RESPONSE_ELEMENT_ID = 'recaptchaResponse';

const submitForm = event => {
    if (!event.target.getAttribute('data-ajax')) {
        event.target.submit();
        return true;
    }
    $.ajax({
        url: event.target.getAttribute('action'),
        type: 'POST',
        data: $(event.target).serialize()
    }).done(response => {
        event.target.reset();
        $(event.target.parentElement).html(response);
    }).fail(response => {
        alert("Sorry, your message could not be sent. Please try again at a later time.");
    });
};

const handleFormSubmit = (event, eventCategory, eventAction, eventLabel) => {
    if (!grecaptcha) return true;
    event.preventDefault();
    grecaptcha.ready(() => {
        grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: eventLabel }).then(token => {
            let recaptchaResponse = document.getElementById(RECAPTCHA_RESPONSE_ELEMENT_ID);
            recaptchaResponse.value = token;
            submitForm(event);
        });
    });
}

window.handleFormSubmit = handleFormSubmit;


/*
avoided having username of email address in plain text; need to decrypt ROT13, and for setting href need to reverse char order
 */
document.querySelectorAll('.encr_usr').forEach((el) =>
    el.innerHTML = el.innerText.replace(/[a-zA-Z]/g,(c)=>String.fromCharCode((c<="Z"?90:122)>=(c=c.charCodeAt(0)+13)?c:c-26))
);
document.querySelectorAll('.msgbkwd').forEach((el) =>
    setTimeout(()=>el.href="mailto:"+el.innerText.split("").reverse().join(""),1000)
);